// extracted by css-extract-rspack-plugin
export default {"textarea":"ArticleTextInputs_textarea__EHbeI"};